module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    attrs: {
      "id": "dimmer"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9ddca90"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Dimmer.vue
// module id = 285
// module chunks = 0